import { AirHandlerTypeType, ItemType } from 'data/types';
import { getRequiredSpaceAttributes } from './required-space-attributes';

export function createDefaultSpaceItem(
  airHandlerTypes: AirHandlerTypeType[],
  attributes: ItemType['attributes']
): ItemType {
  const typeCodes = airHandlerTypes.map((type) => type.code);
  return {
    id: 0,
    group: 'Space',
    allowedAirHandlerTypes: typeCodes,
    airHandlerRanking: typeCodes,
    defaultFenestration: [],
    defaultAppliances: [],
    airHandlerSuggestionOverride: false,
    canBeAlone: true,
    mustBeAlone: false,
    attributes: getRequiredSpaceAttributes(attributes),
    code: '',
    description: '',
    label: '',
    largeSize: null,
    mediumSize: null,
    smallSize: null,
    recommendOversizing: false,
    typicallySharesAir: false
  };
}
